import React from "react";
import { logout } from "../../API/RecordingTableAPI";
import { API_BASE_PATH } from "../../Config/Config";
import SessionExpiredModal from "./SessionExpiredModal";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    if (process.env.NODE_ENV === "development") {
      console.clear();
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    error.preventDefault?.();

    if (process.env.NODE_ENV === "development") {
      const overlay = document.querySelector('iframe[style*="position: fixed"]');
      if (overlay) {
        overlay.style.display = "none";
      }
    }

    this.setState({
      error,
      errorInfo,
      hasError: true,
    });
  }

  handleLogout = () => {
    const userDetails = localStorage.getItem("userDetail");
    const user = userDetails ? JSON.parse(userDetails) : null;
    const isSsoLogin = localStorage.getItem("isSsoLogin") === "true" || user?.isSsoLogin === true;

    if (isSsoLogin && user?.sessionId) {
      localStorage.removeItem("userDetail");
      localStorage.removeItem("payment_completed");
      localStorage.removeItem("colorcode");
      localStorage.removeItem("isSsoLogin");

      const logoutUrl = `${API_BASE_PATH}/KeyLogging/sso/logout?sessionId=${user.sessionId}&uname=${user.email}`;
      window.location.href = logoutUrl;
      return;
    }

    // Non-SSO logout flow
    try {
      logout();
    } catch (_) {}
    localStorage.removeItem("userDetail");
    localStorage.removeItem("payment_completed");
    localStorage.removeItem("colorcode");
    localStorage.removeItem("isSsoLogin");
    window.location.href = "/LoginPage";
  };

  render() {
    if (this.state.hasError) {
      return <SessionExpiredModal onLogout={this.handleLogout} countdown={3} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
